/**
 * Maintenance — branded holding page shown when the admin has flipped
 * Maintenance Mode on in System Settings. Super-admins bypass this
 * gate (they need to be able to disable maintenance) — see App.jsx
 * where the route swap is decided.
 */
import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logoImg from '@assets/images/vowsera_256x256.png';

const Maintenance = ({ message }) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1D1D44 0%, #4C2A85 50%, #9B30FF 100%)',
        color: '#fff',
        padding: '2rem 1rem',
      }}
    >
      <div className="text-center" style={{ maxWidth: 520 }}>
        <img src={logoImg} alt="VowsEra" style={{ height: 96, marginBottom: '1.5rem', borderRadius: 16, boxShadow: '0 6px 24px rgba(0,0,0,0.3)' }} />
        <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🛠️</div>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: '2.2rem', letterSpacing: '-0.5px', marginBottom: '0.75rem' }}>
          We&rsquo;ll be right back
        </h1>
        <p style={{ fontSize: '1.05rem', opacity: 0.9, lineHeight: 1.6, marginBottom: '2rem' }}>
          {message || 'VowsEra is currently undergoing scheduled maintenance. We’ll be back shortly — thanks for your patience!'}
        </p>
        <div className="d-flex gap-2 justify-content-center flex-wrap">
          <Button onClick={() => window.location.reload()} size="lg" style={{ background: '#fff', color: '#9B30FF', fontWeight: 700, border: 'none' }}>
            <i className="bi bi-arrow-clockwise me-1" />Check Again
          </Button>
          <Button as={Link} to="/login" size="lg" variant="outline-light">
            <i className="bi bi-shield-lock me-1" />Admin sign-in
          </Button>
        </div>
        <p className="small mt-4" style={{ opacity: 0.7 }}>
          Need help? Email <a href="mailto:support@vowsera.com" style={{ color: '#fff', textDecoration: 'underline' }}>support@vowsera.com</a>
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
